export default __webpack_public_path__ + "static/media/create-organisation-step-two.1eb9933e.png";